












import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class LogoutCheckModal extends Vue {
    @Prop(Boolean) show: boolean;

    get title() {
        return this.$tc('extranetSecurity.logoutTitle');
    }

    get okTitle() {
        return this.$tc('extranetSecurity.logoutButtonYes');
    }

    get cancelTitle() {
        return this.$tc('extranetSecurity.logoutButtonNo');
    }

    get content() {
        return this.$tc('extranetSecurity.logoutText');
    }

    close() {
        this.$emit('close');
    }

    logout() {
        this.$emit('logout');
    }
}

